import Rest from './rest';

const RESOURCE = "category";

export default {

    list: function () {
        return Rest.get(RESOURCE);
    },
};



// WEBPACK FOOTER //
// ./src/services/CategoryService.js